<template>
  <div class="login">
    <div class="content" v-if="show">
      <img
        v-if="hostname.indexOf('bishui') != -1"
        class="logo-dzm"
        src="../assets/logo-bishui.jpg"
      />
      <img
        v-else-if="
          hostname.indexOf('yuhong') != -1 ||
            hostname.indexOf('dzm') != -1 ||
            hostname.indexOf('dkd') != -1
        "
        class="logo-dzm"
        src="../assets/logo-dzm3.jpg"
      />
      <img v-else class="logo" alt="fsgo logo" src="../assets/logo.png" />
      <el-form :model="form" ref="login">
        <el-form-item
          prop="user"
          :rules="{
            required: true,
            trigger: ['change', 'blur'],
            message: '请输入手机号'
          }"
        >
          <el-input
            v-model="form.user"
            prefix-icon="el-icon-user"
            placeholder="手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="password"
          :rules="{
            required: true,
            trigger: ['change', 'blur'],
            message: '请输入密码'
          }"
        >
          <el-input
            v-model="form.password"
            prefix-icon="el-icon-lock"
            placeholder="密码"
            show-password
            @keyup.enter.native="login"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="imageCode"
          :rules="{
            required: true,
            trigger: ['change', 'blur'],
            message: '请输入验证码'
          }"
        >
          <el-input
            v-model="form.imageCode"
            placeholder="验证码"
            size="medium"
            clearable
            class="c-input-captcha"
          >
            <template slot="append">
              <img
                width="100px"
                height="34px"
                v-if="captcha"
                :src="captcha"
                class="c-flex c-pointer"
                @click="getImageCaptcha()"
              />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="success"
            @click="login()"
            class="width_all"
            :style="
              hostname.indexOf('yuhong') != -1 ||
              hostname.indexOf('dzm') != -1 ||
              hostname.indexOf('bishui') != -1 ||
              hostname.indexOf('dkd') != -1
                ? 'background:#c72922;border:none'
                : ''
            "
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
      <div class="icp" v-if="hostname.indexOf('fsgo365') != -1">
        <div>
          <el-link href="https://beian.miit.gov.cn" target="_blank">
            网站备案号：京ICP备17038172号-3
          </el-link>
        </div>
        <div>
          <el-link href="https://pub.fsgo365.cn/6928577557157426962.jpg" target="_blank">
            经营许可证编号：京B2-20190529号
          </el-link>
        </div>
      </div>
      <div class="icp" v-else-if="hostname.indexOf('fs-go') != -1">
        <div>
          <el-link href="https://beian.miit.gov.cn" target="_blank">
            网站备案号：京ICP备17038172号-4
          </el-link>
        </div>
        <div>
          <el-link href="https://pub.fsgo365.cn/6928577557157426962.jpg" target="_blank">
            经营许可证编号：京B2-20190529号
          </el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: 'login',
  data() {
    window.$this = this;
    return {
      hostname: '',
      form: {
        user: '',
        password: '',
        imageCode: ''
      },
      captcha: '',
      show: true
    };
  },
  beforeMount() {
    // 本地开发和测试环境不需要https
    if (
      (window.location.hostname.indexOf('.com') != -1 ||
        window.location.href.indexOf('.cn') != -1) &&
      window.location.hostname.indexOf('dev') == -1 &&
      window.location.protocol == 'http:'
    ) {
      window.location.protocol = 'https:';
    }
  },
  mounted() {
    this.hostname = window.location.hostname;
    // 根据域名修改登录页logo和标题
    if (this.hostname.indexOf('bishui') != -1) {
      document.querySelector('#titleBroswer').innerHTML = '雨虹闭水服务';
      document.querySelector('#iconTitleBroswer').href =
        'https://pub.fsgo365.cn/6362866227843413516.jpeg';
    } else if (
      this.hostname.indexOf('yuhong') != -1 ||
      this.hostname.indexOf('dzm') != -1 ||
      this.hostname.indexOf('dkd') != -1
    ) {
      document.querySelector('#titleBroswer').innerHTML = '雨虹家服务';
      document.querySelector('#iconTitleBroswer').href = './favicon-dzm.ico';
    }

    //cookie有值无需登录，注销时cookie会赋值为空
    let cookie = this.$util.cookie.get(this.$util.cookieRelative.token);
    if (cookie) {
      this.getAccount();
    }

    this.getImageCaptcha();
  },
  methods: {
    //同一浏览器新建标签页，如果有token不需要重新登录
    getAccount() {
      this.osg.ajax(
        '/account/getOneself.do',
        {},
        res => {
          sessionStorage['entity'] = JSON.stringify(res);
          this.osg.customize.bizId = res.entityID;
          this.osg.customize.entity = res;
          //获取菜单
          this.$router.push('/NavMenu');
        },
        {
          noload: true
        }
      );
    },
    //登录
    login() {
      if (this.osg.validate('login')) {
        //将登陆信息放入请求头
        let userdetail =
          this.$util.cookieRelative.basic +
          ' ' +
          this.$util.Base64.encode(this.form.user + ':' + this.form.password);
        let header = {};
        header[this.$util.cookieRelative.authorization] = userdetail;
        this.osg.ajax(
          'login',
          { imageCode: this.form.imageCode },
          res => {
            //登陆信息有误时提示
            if (!res.data.success) {
              if (res.data.message) this.osg.alert(res.data.message);
              return;
            }

            // //将客户是否有外呼权限放入缓存
            // window.sessionStorage['userData'] = JSON.stringify(res.data.data);

            //将用户信息存到sessionStorage
            window.sessionStorage['entity'] = JSON.stringify(res.data.entity);
            this.osg.customize.bizId = res.data.entity.entityID;
            this.osg.customize.entity = res.data.entity;

            //获取响应x-auth-token 并将token存到cookie

            let token = res.headers['x-auth-token'];
            this.$util.cookie.set(
              this.$util.cookieRelative.token,
              token,
              this.$util.cookieRelative.tokenExpires
            );

            //重新登录清除数据缓存
            window.sessionStorage.removeItem('preFilter');
            window.sessionStorage.removeItem('filter');
            window.sessionStorage.removeItem('dashboardsChoose');
            window.localStorage.removeItem('roleChangeData');

            //获取菜单
            this.$router.push('/NavMenu');
          },
          { header }
        );
      }
    },
    // 获取验证码
    getImageCaptcha() {
      this.osg.getImageCaptcha(captcha => {
        this.captcha = captcha;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  width: 200px;
  margin-bottom: 50px;
}
.logo-dzm {
  width: 300px;
  // margin-left: 15px;
  margin-bottom: 50px;
}
.content {
  width: 300px;
  margin: 100px auto;
  text-align: center;
  .c-input-captcha {
    ::v-deep .el-input-group__append {
      padding: 0;
      overflow: hidden;
    }
  }
}
.width_all {
  width: 100%;
}

.icp {
  width: 100%;
  position: fixed;
  bottom: 10px;
  left: 0;
}
</style>
